import { WRITTEN_ID_VERIFICATION_SECTIONS } from '@/data/exam.notice.data';

import WrittenNoticeSheetSectionCard from './written-notice-sheet-section-card.client';

/** 준비물 > 신분증 인증 범위 BottomSheet 본문(헤더는 BottomSheet `headerContent`) */
export default function WrittenPrepIdVerificationSheet() {
  return (
    <div className="bg-[#F5F5FA] px-3 pb-8 pt-5">
      <div className="flex flex-col gap-5">
        {WRITTEN_ID_VERIFICATION_SECTIONS.map((section) => (
          <WrittenNoticeSheetSectionCard
            key={section.title}
            section={section}
          />
        ))}
      </div>
    </div>
  );
}
